module.exports = __webpack_public_path__ + "pink-dawn.png?871b5b84d56c345f8573dc6d2a64dbf9";